/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageEvacOrderOverviewPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/dom-style',
        'dojo/text!./templates/SignageEvacOrderOverviewPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        //'../../config',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageEvacOrderOverivewPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageEvacOrderOverviewPage~SignageEvacOrderOverviewPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 6,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'prefDisasterOccurEvacHouseholdNum', 'area':'prefDisasterOccurEvacHouseholdNumArea'},
                {'item':'prefDisasterOccurEvaqueeNum', 'area':'prefDisasterOccurEvaqueeNumArea'},
                {'item':'prefInstructionEvacHouseholdNum', 'area':'prefInstructionEvacHouseholdNumArea'},
                {'item':'prefInstructionEvaqueeNum', 'area':'prefInstructionEvaqueeNumArea'},
                {'item':'prefPreparationEvacHouseholdNum', 'area':'prefPreparationEvacHouseholdNumArea'},
                {'item':'prefPreparationEvaqueeNum', 'area':'prefPreparationEvaqueeNumArea'},
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                this.setEvacOrderOviewviewInfo();
            },

            /**
             * 避難情報概況を設定します
             */
            setEvacOrderOviewviewInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 避難情報を設定
                    var prefEvacOrderInfo = item.items.filter(function(element) {
                        return element.municipalityCd === null;
                    });
                    this.setPrefEvacOrderInfo(this, prefEvacOrderInfo);
                    var municEvacOrderInfo = item.items.filter(function(element) {
                        return element.municipalityCd !== null;
                    });
                    this.setMunicEvacOrderInfo(this, municEvacOrderInfo);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var prefEvacOrderInfo = {};
                        this.setPrefEvacOrderInfo(this, prefEvacOrderInfo);
                        var municEvacOrderInfo = [];
                        this.setMunicEvacOrderInfo(this, municEvacOrderInfo);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 県の避難情報を設定します
             */
            setPrefEvacOrderInfo: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item].toLocaleString() ;
                });

                // 0世帯＆0人の場合の背景色・文字色変更
                if (item[0].prefDisasterOccurEvacHouseholdNum === 0 && item[0].prefDisasterOccurEvaqueeNum === 0) {
                    domClass.remove(this.prefDisasterOccurArea, 'occur');
                    domClass.add(this.prefDisasterOccurArea, 'none');
                } 
                if (item[0].prefInstructionEvacHouseholdNum === 0 && item[0].prefInstructionEvaqueeNum === 0) {
                    domClass.remove(this.prefInstructionArea, 'oder');
                    domClass.add(this.prefInstructionArea, 'none');
                } 
                if (item[0].prefPreparationEvacHouseholdNum === 0 && item[0].prefPreparationEvaqueeNum === 0) {
                    domClass.remove(this.prefPreparationArea, 'prepare');
                    domClass.add(this.prefPreparationArea, 'none');
                } 

                // 更新状態を設定
                this.setPrefEvacOrderInfoUpdate(self, item);
            },

            /**
             * 県の避難情報の更新状態を設定します
             */
            setPrefEvacOrderInfoUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem) {
                    return;
                }
                var prefEvacOrderInfo = prevItem.items[0];
                if (prefEvacOrderInfo) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (prefEvacOrderInfo[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 避難情報一覧を設定します
             */
            setMunicEvacOrderInfo: function(self, data) {
                // 表示をクリア
                var evacOrderOverviewTBody = dojo.byId('evacOrderOverviewTBody');
                domConstruct.empty(evacOrderOverviewTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                if (data.length <= this.PAGE_LIST_SIZE) {
                    domStyle.set(this.pageArea, 'display', 'none');
                } else {
                    self.currentPage.innerHTML = this._page + 1;
                    self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);    
                }

                var prevItem = prevItemStore[this._screenId];
                var evacOrderOverview = [];
                if (prevItem) {
                    evacOrderOverview = prevItem.items.filter(function(element) {
                        return element.municipalityCd !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function(item){
                    // 避難所の前回値
                    var evacOrderPrevItem = null;
                    if (evacOrderOverview) {
                        evacOrderPrevItem = evacOrderOverview.filter((element) =>
                            element.municipalityCd === item.municipalityCd
                        )[0];
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');

                    // 市町村
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.municipalityName, class: 'align-middle text-center fw-bold first-col'}), tr);

                    // 緊急安全確保 避難地区数/全地区数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municDisasterOccurDistrictNum !== item.municDisasterOccurDistrictNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municDisasterOccurDistrictNum + '/' + item.municAllDistrictNum + '</span>', class: className}), tr);

                    // 緊急安全確保 避難世帯数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municDisasterOccurEvacHouseholdNum !== item.municDisasterOccurEvacHouseholdNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municDisasterOccurEvacHouseholdNum.toLocaleString() + '</span>' + ' 世帯', class: className}), tr);

                    // 緊急安全確保 人数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municDisasterOccurEvaqueeNum !== item.municDisasterOccurEvaqueeNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municDisasterOccurEvaqueeNum.toLocaleString() + '</span>' + ' 人', class: className}), tr);

                    // 避難指示 避難地区数/全地区数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municInstructionDistrictNum !== item.municInstructionDistrictNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municInstructionDistrictNum + '/' + item.municAllDistrictNum + '</span>', class: className}), tr);

                    // 避難指示 避難世帯数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municInstructionEvacHouseholdNum !== item.municInstructionEvacHouseholdNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municInstructionEvacHouseholdNum.toLocaleString() + '</span>' + ' 世帯', class: className}), tr);

                    // 避難指示 人数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municInstructionEvaqueeNum !== item.municInstructionEvaqueeNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municInstructionEvaqueeNum.toLocaleString() + '</span>' + ' 人', class: className}), tr);

                    // 高齢者等避難 避難地区数/全地区数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municPreparationDistrictNum !== item.municPreparationDistrictNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municPreparationDistrictNum + '/' + item.municAllDistrictNum + '</span>', class: className}), tr);

                    // 高齢者等避難 避難世帯数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municPreparationEvacHouseholdNum !== item.municPreparationEvacHouseholdNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municPreparationEvacHouseholdNum.toLocaleString() + '</span>' + ' 世帯', class: className}), tr);

                    // 高齢者等避難 人数
                    className = evacOrderPrevItem && (evacOrderPrevItem.municPreparationEvaqueeNum !== item.municPreparationEvaqueeNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municPreparationEvaqueeNum.toLocaleString() + '</span>' + ' 人', class: className}), tr);

                    domConstruct.place(tr, evacOrderOverviewTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }  

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setMunicEvacOrderInfo(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }
        });
    });
